module.exports = __webpack_public_path__ + "static/media/3.Big Engine Operated Sprayer.0374f130.jpg";